import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2416eb3a")

_pushScopeId("data-v-2416eb3a")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", { class: "header-margin" }, "Global Configuration", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Report Builder ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Geotab ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Open Weather Map ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_container = _resolveComponent("el-container")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_ReportBuilderTab = _resolveComponent("ReportBuilderTab")
  const _component_GeotabTab = _resolveComponent("GeotabTab")
  const _component_OpenWeatherMapTab = _resolveComponent("OpenWeatherMapTab")

  return (_openBlock(), _createBlock(_component_el_container, { direction: "horizontal" }, {
    default: _withId(() => [
      _createVNode(_component_el_aside, {
        width: "250px",
        class: "menu-aside"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_container, { direction: "vertical" }, {
            default: _withId(() => [
              _hoisted_1,
              _createVNode(_component_el_button, {
                onClick: _ctx.routeToReportBuilder,
                class: "margin-none"
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: _ctx.routeToGeotab,
                class: "margin-none"
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: _ctx.routeToOpenWeatherMap,
                class: "margin-none"
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.editTab === 'report-builder')
        ? (_openBlock(), _createBlock(_component_ReportBuilderTab, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.editTab === 'geotab')
        ? (_openBlock(), _createBlock(_component_GeotabTab, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.editTab === 'open-weather-map')
        ? (_openBlock(), _createBlock(_component_OpenWeatherMapTab, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})